import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface MetricTile {
  id: string;
  name: string;
  enabled: boolean;
  order: number;
}

interface MetricStore {
  metrics: MetricTile[];
  updateMetricOrder: (metrics: MetricTile[]) => void;
  toggleMetric: (id: string) => void;
  resetToDefault: () => void;
}

const defaultMetrics: MetricTile[] = [
  { id: 'steps', name: 'Steps', enabled: true, order: 0 },
  { id: 'calories', name: 'Calories', enabled: true, order: 1 },
  { id: 'resting-hr', name: 'Resting HR', enabled: true, order: 2 },
  { id: 'vo2-max', name: 'VO2 Max', enabled: true, order: 3 }
];

export const useMetricStore = create<MetricStore>()(
  persist(
    (set, get) => ({
      metrics: defaultMetrics,
      
      updateMetricOrder: (metrics) => {
        const orderedMetrics = metrics.map((metric, index) => ({
          ...metric,
          order: index
        }));
        set({ metrics: orderedMetrics });
      },
      
      toggleMetric: (id) => set((state) => {
        const enabledCount = state.metrics.filter(m => m.enabled).length;
        const metric = state.metrics.find(m => m.id === id);
        
        if (!metric?.enabled && enabledCount >= 4) {
          return state;
        }

        const updatedMetrics = state.metrics.map(m => 
          m.id === id ? { ...m, enabled: !m.enabled } : m
        );

        const enabledMetrics = updatedMetrics.filter(m => m.enabled);
        const disabledMetrics = updatedMetrics.filter(m => !m.enabled);
        
        const reorderedMetrics = [
          ...enabledMetrics.map((m, i) => ({ ...m, order: i })),
          ...disabledMetrics.map((m, i) => ({ ...m, order: enabledMetrics.length + i }))
        ];

        return { metrics: reorderedMetrics };
      }),
      
      resetToDefault: () => set({ metrics: defaultMetrics })
    }),
    {
      name: 'metric-preferences',
      version: 4,
      migrate: (persistedState: any, version: number) => {
        if (version < 4) {
          return { metrics: defaultMetrics };
        }
        return persistedState as MetricStore;
      }
    }
  )
);